import React from 'react'
import { ThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import { createTheme } from '@material-ui/core/styles'
import StandaloneJsonEditor from './pages/StandaloneJsonEditor'
import GlobalStyles from './styles'

const theme = createTheme({
  palette: {
    primary: {
      main: '#3f51b5',
    },
    secondary: {
      main: '#f50057',
    },
  },
})

const StandaloneApp: React.FC = () => {
  return (
    <>
      <GlobalStyles />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <StandaloneJsonEditor />
      </ThemeProvider>
    </>
  )
}

export default StandaloneApp
